<div class="row">
  <div class="col-12">
    <div class="content-header">Contact Form</div>
  </div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <form [formGroup]="contactForm">
                  <fieldset class="form-group">
                    <label for="name">Name</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="name"
                      [(ngModel)]="contact_model.name"
                      id="name"
                      placeholder="Enter Name"
                      [ngClass]="{
                        'is-invalid':
                          contactFormSubmitted && rf.name.invalid,
                        'is-valid':
                        contactFormSubmitted && !rf.name.invalid
                      }"
                      required
                    #name/>
                    <div
                      *ngIf="
                      rf.name.touched &&
                        (rf.name.invalid ||
                          rf.name.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Name
                      is required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="Email">Email</label>
                    <input
                      type="email"
                      class="form-control"
                      formControlName="email"
                      [(ngModel)]="contact_model.email"
                      id="Email"
                      placeholder="Enter email"
                                         #email
                    />
                    <!-- <div
                      *ngIf="rf.email.touched && rf.email?.errors?.required"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Email is
                      required
                    </div> -->
                   
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="phone">Phone</label>
                    <input
                      class="form-control"
                      formControlName="phone" [(ngModel)]="contact_model.phone"
                      id="phone"
                      type="text" placeholder="e.g. 1234-567-890"
                      mask="0000-000-000" minlength="10"
                     />
                  </fieldset>
                  <fieldset class="form-group" *ngIf="!contact">
                    <label for="address">Location</label>
                    <input
                      type="text"
                      (keydown.enter)="$event.preventDefault()"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="off"
                      class="form-control"
                      formControlName="address"
                      id="location"
                      placeholder="Enter location"
                    #search/> 
                  </fieldset>
                  <fieldset class="form-group" *ngIf="contact">
                    <label for="address">Location</label>
                    <input
                      type="text"
                      (keydown.enter)="$event.preventDefault()"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="off"
                      class="form-control"
                      [(ngModel)]="contact_model.address" [ngModelOptions]="{standalone: true}"
                      id="location"
                      placeholder="Enter location"
                    #search/> 
                  </fieldset>
                  <!-- <fieldset class="form-group" *ngIf="contact">
                    <label for="landmark">Landmark</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="landmark"
                      [(ngModel)]="contact.landmark"
                      id="landmark"
                      placeholder="Enter landmark"
                    /> 
                  </fieldset> -->
                  <div class="form-group">
                    <label class="form-control-label mb-1" for="college">Business</label>
                    <fieldset class="position-relative has-icon-right">
                      <ng-select [items]="business_list" bindLabel="name" bindValue="_id" placeholder="Select Business"
                        [(ngModel)]="select_business" [ngModelOptions]="{standalone: true}" (change)="getBusinessId($event)">
                      </ng-select>
                    </fieldset>
                  </div>
                  <div class="form-group">
                    <label class="form-control-label mb-1" for="college">Business Type</label>
                    <fieldset class="position-relative has-icon-right">
                      <ng-select [items]="business_type_List" bindLabel="displayname" bindValue="_id" placeholder="Select business type"
                        [(ngModel)]="select_business_type" [ngModelOptions]="{standalone: true}" (change)="getBusinessType($event)">
                      </ng-select>
                    </fieldset> 
                  </div>
                  <div class="form-group">
                    <label class="form-control-label mb-1">Refrence</label>
                    <fieldset class="position-relative has-icon-right">
                      <ng-select [items]="users_List" bindLabel="name" bindValue="_id" placeholder="Select Refrence"
                        [(ngModel)]="select_refrence" [ngModelOptions]="{standalone: true}" (change)="getRefrenceId($event)">
                      </ng-select>
                    </fieldset> 
                  </div>
                  <div class="form-group">
                    <label class="form-control-label mb-1">Role</label>
                    <fieldset class="position-relative has-icon-right">
                      <ng-select [items]="role_List" bindLabel="name" bindValue="_id" placeholder="Select Role"
                        [(ngModel)]="select_role" [ngModelOptions]="{standalone: true}" (change)="getRoleId($event)">
                      </ng-select>
                    </fieldset> 
                  </div>
                </form>
              </div>
              <div class="col-md-6">
                <form [formGroup]="contactForm">
                  
                  <!-- <div class="form-group">
                    <label class="form-control-label mb-1" for="college">Social Media</label>
                    <fieldset class="position-relative has-icon-right">
                      <ng-select [items]="socailmediaList" bindLabel="displayname" bindValue="_id" placeholder="Select social media"
                        [(ngModel)]="select_socialmedia" [ngModelOptions]="{standalone: true}" (change)="getChangeSocialMedia($event)">
                      </ng-select>
                    </fieldset> 
                  </div> -->
                  <fieldset class="form-group">
                    <label>Refrences</label>
                    <quill-editor [(ngModel)]="contact_model.refrences" [ngModelOptions]="{standalone: true}"  (onContentChanged)="setFocus($event)"></quill-editor>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="name">Notes</label>
                    <textarea
                      id="hidden-label-form-6"
                      rows="3"
                      class="form-control"
                      formControlName="notes"
                      [(ngModel)]="contact_model.notes" 
                      id="name"
                      placeholder="Enter notes"
                    ></textarea>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="admin_notes">Admin Notes</label>
                    <textarea
                      id="hidden-label-form-6"
                      rows="3"
                      class="form-control"
                      formControlName="admin_notes"
                      [(ngModel)]="contact_model.admin_notes"
                      id="admin_notes"
                      placeholder="Enter admin notes"
                    ></textarea>
                  </fieldset>
                  <div
                    class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                  >
                    <button
                      type="submit"
                      class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                      (click)="submit()"
                    >
                      Submit
                    </button>
                    <button
                      type="reset"
                      class="btn btn-secondary"
                      (click)="back()"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
